import { createEffect, createEvent, createStore, sample } from 'effector'
import {
  AccountSurveyCounter,
  ChangeTaskSurveyFormOpenStatus,
  FetchTaskParams,
  FetchTaskSurveyAnswerParams,
  TaskBasicInfo,
  TaskSurveyAnswerStatus,
  TaskSurveyFormOpenStatus,
} from './model'
import { fetchAccountSurveyCounter, fetchTaskInfo, fetchTaskSurveyAnswer } from './api'

const $accountSurveyCounterStore = createStore<AccountSurveyCounter | null>(null)
const $taskSurveyFormOpenStatusStore = createStore<TaskSurveyFormOpenStatus>({
  isOpen: false,
  taskStore: 'latest',
})

const $latestDoneTaskStore = createStore<TaskBasicInfo | null>(null)
const $currentTaskStore = createStore<TaskBasicInfo | null>(null)
const $latestDoneTaskSurveyAnswerStore = createStore<TaskSurveyAnswerStatus | null>(null)
const $currentTaskSurveyAnswerStore = createStore<TaskSurveyAnswerStatus | null>(null)
const $taskSurveyFormSubmittingStore = createStore(false)
const $taskSurveyButtonStatusStore = createStore(false)

const fetchAccountSurveyCounterEvent = createEvent()
const setTaskSurveyFormOpenStatusEvent = createEvent<ChangeTaskSurveyFormOpenStatus>()
const fetchLatestDoneTaskEvent = createEvent<FetchTaskParams>()
const fetchCurrentTaskEvent = createEvent<FetchTaskParams>()
const fetchLatestDoneTaskSurveyAnswerEvent = createEvent<FetchTaskSurveyAnswerParams>()
const fetchCurrentTaskSurveyAnswerEvent = createEvent<FetchTaskSurveyAnswerParams>()
const setTaskSurveyFormSubmittingEvent = createEvent<boolean>()
const setTaskSurveyButtonStatusEvent = createEvent<boolean>()

/**
 * Получение данных счетчика опросов
 */
const fetchAccountSurveyCounterFx = createEffect(fetchAccountSurveyCounter)
$accountSurveyCounterStore.on(fetchAccountSurveyCounterFx.doneData, (state, data) => {
  return data
    ? {
        ...state,
        ...(data as AccountSurveyCounter),
      }
    : state
})

/**
 * Статус открытия формы опроса
 */
$taskSurveyFormOpenStatusStore.on(setTaskSurveyFormOpenStatusEvent, (state, payload) => ({ ...state, ...payload }))

/**
 * Получение информации по последней завершенной задаче
 */
const fetchLatestDoneTaskFx = createEffect(fetchTaskInfo)
$latestDoneTaskStore.on(fetchLatestDoneTaskFx.doneData, (_, data) => data)

/**
 * Получение статуса прохождения опроса по последней завершенной задаче
 */
const fetchLatestDoneTaskSurveyAnswerFx = createEffect(fetchTaskSurveyAnswer)
$latestDoneTaskSurveyAnswerStore.on(fetchLatestDoneTaskSurveyAnswerFx.doneData, (_, data) => data)

/**
 * Получение информации по текущей открытой задаче
 */
const fetchCurrentTaskInfoFx = createEffect(fetchTaskInfo)
$currentTaskStore.on(fetchCurrentTaskInfoFx.doneData, (state, data) => {
  return data ? { ...state, ...(data as TaskBasicInfo) } : state
})

/**
 * Получение статуса прохождения опроса по текущей открытой задаче
 */
const fetchCurrentTaskSurveyAnswerFx = createEffect(fetchTaskSurveyAnswer)
$currentTaskSurveyAnswerStore.on(fetchCurrentTaskSurveyAnswerFx.doneData, (_, data) => data)

/**
 * Статус отправки формы опроса
 */
$taskSurveyFormSubmittingStore.on(setTaskSurveyFormSubmittingEvent, (_, payload) => payload)

/**
 * Статус кнопки для открытия формы опроса
 */
$taskSurveyButtonStatusStore.on(setTaskSurveyButtonStatusEvent, (_, payload) => payload)

sample({
  clock: fetchAccountSurveyCounterEvent,
  target: fetchAccountSurveyCounterFx,
})

sample({
  clock: fetchLatestDoneTaskEvent,
  target: fetchLatestDoneTaskFx,
})

sample({
  clock: fetchLatestDoneTaskSurveyAnswerEvent,
  target: fetchLatestDoneTaskSurveyAnswerFx,
})

sample({
  clock: fetchCurrentTaskSurveyAnswerEvent,
  target: fetchCurrentTaskSurveyAnswerFx,
})

sample({
  clock: fetchCurrentTaskEvent,
  target: fetchCurrentTaskInfoFx,
})

export const taskSurveyEffectorModel = {
  fetchAccountSurveyCounterEvent,
  fetchCurrentTaskEvent,
  fetchLatestDoneTaskEvent,
  fetchLatestDoneTaskSurveyAnswerEvent,
  fetchCurrentTaskSurveyAnswerEvent,
  setTaskSurveyFormOpenStatusEvent,
  setTaskSurveyFormSubmittingEvent,
  setTaskSurveyButtonStatusEvent,
  $accountSurveyCounterStore,
  $currentTaskStore,
  $latestDoneTaskStore,
  $latestDoneTaskSurveyAnswerStore,
  $currentTaskSurveyAnswerStore,
  $taskSurveyFormOpenStatusStore,
  $taskSurveyFormSubmittingStore,
  $taskSurveyButtonStatusStore,
}
